import { SortItem } from './member.dashboard.license.response';

export interface IGracePeriodReportItem  {
    AutomationBillingActiveID: number;

    Created: Date;
    NextAttempt: Date;

    MemberFullName: string;
    MemberID: number;

    LicenseKey: string;
    LicenseID: number;

    TriggerDay: number;
    NextAttemptTriggerDay: number;

    CurrentAction: string;
    NextAction: string;
}

export class GracePeriodReportItem  implements IGracePeriodReportItem {
    AutomationBillingActiveID: number;
    Created: Date;
    NextAttempt: Date;
    MemberFullName: string;
    MemberID: number;
    LicenseKey: string;
    LicenseID: number;
    TriggerDay: number;
    NextAttemptTriggerDay: number;
    CurrentAction: string;
    NextAction: string;

    public static FixDates(item: GracePeriodReportItem) {
        item.Created = new Date(item.Created);
        item.NextAttempt = new Date(item.NextAttempt);
    }
}


export class GracePeriodReportItemArray extends Array<GracePeriodReportItem> {
    public LastSort: SortItem;

    constructor(...items: GracePeriodReportItem[]) {
        super(...items);
        Object.setPrototypeOf(this, GracePeriodReportItemArray.prototype);
    }

    public static FixDates(items: GracePeriodReportItemArray) {
        items.forEach(x => GracePeriodReportItem.FixDates(x));
    }

}
